import { ethers } from "ethers";
import config from './config';
import viciCommon from './viciCommon';
import './css/viciCommon.css';
import './css/terabithia.css';
import reverse from './img/reverse.png';

$(function() {
	//Globals
	let from = {};
	let to = {};
	let signer;
	let accounts;

	(async function init(){
		viciCommon.addMessage("Loading...", "message", 30000);

		//Set up remote logging
		//console = await viciCommon.initLogSocket(config.lumberjackLocation, 'terabithia');

		//Add ?test to the end of the URL to switch to testnet
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		if(params.test===''){
			console.debug('Running on testnet');
			config.network='test';
			from.chainId=84532;
			to.chainId=11155111;
			$('#test').html('Testnet');
			//$('#test').fadeIn('slow');
		}else if(params.arb===''){
			console.debug('Running on Arbitrum');
			config.network='prod';
			from.chainId=137;
			to.chainId=42161;
			$('#test').html('Arbitrum');
			//$('#test').fadeIn('slow');
		}else if(params.opt===''){
			console.debug('Running on Optimism');
			config.network='prod';
			from.chainId=137;
			to.chainId=10;
			$('#test').html('Optimism');
			//$('#test').fadeIn('slow');
		}else if(params.ava===''){
			console.debug('Running on Avalanche');
			config.network='prod';
			from.chainId=137;
			to.chainId=43114;
			$('#test').html('Avalanche');
			//$('#test').fadeIn('slow');
		}else if(params.bnb===''){
			console.debug('Running on BNB');
			config.network='prod';
			from.chainId=137;
			to.chainId=56;
			$('#test').html('BNB');
			//$('#test').fadeIn('slow');
		}else if(params.blast===''){
			console.debug('Running on Blast');
			config.network='prod';
			from.chainId=137;
			to.chainId=81457;
			$('#test').html('Blast');
			//$('#test').fadeIn('slow');
		}else if(params.eth===''){
			console.debug('Running on Ethereum');
			config.network='prod';
			from.chainId=137;
			to.chainId=1;
			$('#test').html('Ethereum');
			//$('#test').fadeIn('slow');
		}else{
			console.debug('Running on Base');
			config.network='prod';
			from.chainId=137;
			to.chainId=8453;
			$('#test').html('Base');
			//$('#test').fadeIn('slow');
		}

		console.debug("Connecting wallet");
		viciCommon.addMessage("Connecting wallet", "message", 30000);
		viciCommon.nextMessage();
		if(window.vicinft.initialized===false){//We can't guarantee that init has finished so we wait for promise
			await window.vicinft.waitForInit();
		}
		window.vicinft.config.chainId=from.chainId;

		let providerRes = await window.vicinft.getProvider();
		let provider = providerRes.provider;
		accounts = await provider.request({method: 'eth_requestAccounts'});

		$('#address').text(accounts[0]);
		console.log("User's wallet address is "+accounts[0]);
		let eProvider = new ethers.BrowserProvider(provider);
		signer = await eProvider.getSigner();

		viciCommon.addMessage("Setting up blockchain interfaces", "message", 30000);
		viciCommon.nextMessage();
		from.provider = new ethers.JsonRpcProvider(config.rpcs[from.chainId]);

		to.provider = new ethers.JsonRpcProvider(config.rpcs[to.chainId]);
		from.coinInstance = new ethers.Contract(config.coinContracts[from.chainId] , config.coinAbi , from.provider);
		to.coinInstance = new ethers.Contract(config.coinContracts[to.chainId] , config.coinAbi , to.provider);
		from.decimals = await from.coinInstance.decimals();
		to.decimals = await to.coinInstance.decimals();

		from.chainName = config.chainNames[from.chainId];
		from.abbreviation = config.abbreviations[from.chainId];
		to.chainName = config.chainNames[to.chainId];
		from.symbol = await from.coinInstance.symbol();
		to.symbol = await to.coinInstance.symbol();

		await setBalances(from, to, accounts[0], true);
		setInterval(async function(){
			await setBalances(from, to, accounts[0], false);
		}, 60000)
		await setupForm(from, to);

		provider.on('chainChanged', function(chainId){
			chainId = parseInt(chainId, 16);
			console.log("Now on chain "+chainId)
		});

		$('#wrapper').fadeIn('slow');
	})();


	$('#do_swap').click(async function(){
		if($('#from_amount').val()==''){
			viciCommon.addMessage("You must set an amount to bridge", "error", 30000);
			viciCommon.nextMessage();
			return;
		}

		if(parseFloat($('#from_amount').val())<=0){
			viciCommon.addMessage("Amount to bridge must be more than zero", "error", 30000);
			viciCommon.nextMessage();
			return;
		}

		if(parseFloat($('#from_amount').val()) > parseFloat(ethers.formatUnits(from.balance.toString(), from.decimals))){
			viciCommon.addMessage("You can't swap more coins than you own!", "error", 30000);
			viciCommon.nextMessage();
			return;
		}

		const res_chainId = await signer.provider.getNetwork();
		let curChainId = parseInt(res_chainId.chainId);

		if(curChainId != from.chainId){
			viciCommon.addMessage("Switching chains", "message", 30000);
			viciCommon.nextMessage();
			if(window.vicinft.provider.isMagic){
				window.vicinft.config.chainId=from.chainId;
				let providerRes = await window.vicinft.getProvider();
				let provider = providerRes.provider;
				let eProvider = new ethers.BrowserProvider(provider);
				signer = await eProvider.getSigner();
			}else{
				window.vicinft.config.chainId=from.chainId;
				await window.vicinft.switchChain();
				let eProvider = new ethers.BrowserProvider(window.vicinft.provider);
				signer = await eProvider.getSigner();
			}
		}
		console.debug("Bridging "+$('#from_amount').val()+ " to "+to.chainId);
		viciCommon.addMessage("Estimating fee", "message", 30000);
		console.debug("Estimating fee");
		viciCommon.nextMessage();

		let tunnelInstance = new ethers.Contract(config.tunnelContracts[from.chainId] , config.tunnelAbi , signer);
		let address = await signer.getAddress();
		console.debug("Got signer and contract");


		let fee = await tunnelInstance.estimateSendFee([address, to.chainId, address, 1, ethers.parseUnits($('#from_amount').val(), from.decimals).toString()], false, "0x").catch((error) => {
			console.log("Error getting the bridge fee", error);
			viciCommon.addMessage("Error estimating fee, please try again", "error", 30000);
			viciCommon.nextMessage();
		});
		console.debug("Got fee "+fee[0]);

		if(fee){
			let feeToUse = BigInt(fee[0]);
			feeToUse = (feeToUse * 102n) / 100n;//Add in 2% to make it less likely to fail (extra gets refunded)

			console.log("Calculated fee needed to bridge is "+(ethers.formatUnits(feeToUse.toString(), from.decimals).toString())+". The user's "+config.nativeCoins[from.chainId]+" "+parseFloat(ethers.formatUnits(String(from.naitivebalance), from.decimals).toString()).toFixed(18)+" balance")
			if(parseFloat(feeToUse.toString()) > parseFloat(from.naitivebalance)){
				viciCommon.addMessage("You don't have enough "+config.nativeCoins[from.chainId]+" to pay the bridge fees. You have "+parseFloat(ethers.formatUnits(String(from.naitivebalance), from.decimals).toString()).toFixed(18)+" you need "+parseFloat(ethers.formatUnits(feeToUse.toString(), from.decimals).toString()).toFixed(18), "error", 30000);
				viciCommon.nextMessage();
				return;
			}

			let value = String($('#from_amount').val());
			//Why?
			// if(value.indexOf('.') > -1 && value.indexOf('.') < (value.length - 1) ){
			// 	value=value.substring(0, value.length - 1);
			// }

			const transaction = await tunnelInstance.sendFrom.populateTransaction(
				[address, to.chainId, address, 1, ethers.parseUnits(value, from.decimals).toString()],
				address,
				'0x0000000000000000000000000000000000000000',
				'0x',
				{value: feeToUse.toString()}
			).catch((error) => {
				console.error("Error making bridge transaction", error);
			});

			if(transaction){
				console.debug("Executing bridge transaction");
				viciCommon.addMessage("Executing bridge transaction", "message", 30000);
				viciCommon.nextMessage();
				let bridgeRes = await signer.sendTransaction(transaction).catch((error) => {
					console.error("Error executing bridge transaction", error);
					console.error(JSON.stringify(error));
					viciCommon.addMessage("Error executing bridge transaction", "error", 30000);
					viciCommon.nextMessage();
				});

				if(bridgeRes && bridgeRes.hash){
					console.debug("Waiting for approval");
					viciCommon.addMessage("Waiting for bridge transaction to be confirmed", "message", 60000);
					viciCommon.nextMessage();
					await from.provider.waitForTransaction(bridgeRes.hash);

					console.debug("Bridge submitted successfully hash="+bridgeRes.hash);
					viciCommon.addMessage(`Bridge transaction submitted successfully. Transactions can take 20 minutes to complete, <a href="https://layerzeroscan.com/tx/${bridgeRes.hash}" target="_blank">you can check its status here</a>`, "message", 14400000);
					viciCommon.nextMessage();
					$('#from_amount').val('');
				}
			}
		}

	});

	$('#reverse').click(async function(){
		[from, to] = [to, from];


		setupForm(from, to);
		let address = await signer.getAddress();
		setBalances(from, to, address, false);
	});

	$('#from_max').click(function(){
		$('#from_amount').val(ethers.formatUnits(from.balance.toString(), from.decimals));
		$('#to_amount').text(ethers.formatUnits(from.balance.toString(), from.decimals));
	});

	// $('#from_amount').keyup(function(){
	// 	if(parseFloat($('#from_amount').val()) > 0){
	// 		$('#to_amount').text(parseFloat(parseFloat($('#from_amount').val()).toFixed(18)));
	// 	}
	// });

	$(document).on('change','#chain_select', async function(event) {
		let cid=$(this).val();

		let abbreviation=config.abbreviations[cid];
//	window.location.search = abbreviation;
		if(from.chainId==137){
			to.chainId=cid;

			$('#test').text(config.chainNames[to.chainId]);
			if ('URLSearchParams' in window) {
				var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+abbreviation;
				window.history.pushState({ path: refresh }, '', refresh);
			}

			to.provider = new ethers.JsonRpcProvider(config.rpcs[to.chainId]);
			to.coinInstance = new ethers.Contract(config.coinContracts[to.chainId] , config.coinAbi , to.provider);
			to.decimals = await to.coinInstance.decimals();
			to.chainName = config.chainNames[to.chainId];
			to.symbol = await to.coinInstance.symbol();

			await setBalances(from, to, accounts[0], true);
			setInterval(async function(){
				await setBalances(from, to, accounts[0], false);
			}, 60000)
			await setupForm(from, to);
		}else{
			from.chainId=cid;
			viciCommon.addMessage("Setting up blockchain interfaces", "message", 30000);
			viciCommon.nextMessage();



			from.provider = new ethers.JsonRpcProvider(config.rpcs[from.chainId]);
			from.coinInstance = new ethers.Contract(config.coinContracts[from.chainId] , config.coinAbi , from.provider);
			from.decimals = await from.coinInstance.decimals();
			from.chainName = config.chainNames[from.chainId];
			from.symbol = await from.coinInstance.symbol();

			window.vicinft.config.chainId=from.chainId;
			await window.vicinft.switchChain();
			let eProvider = new ethers.BrowserProvider(window.vicinft.provider);
			signer = await eProvider.getSigner();

			$('#test').html(config.chainNames[from.chainId]);
			if ('URLSearchParams' in window) {
				var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+abbreviation;
				window.history.pushState({ path: refresh }, '', refresh);
			}

			await setBalances(from, to, accounts[0], true);
			setInterval(async function(){
				await setBalances(from, to, accounts[0], false);
			}, 60000)
			await setupForm(from, to);
		}
	});


	async function setupForm(from, to){
		let chainSelect = '<select id="chain_select">';
		for(let [cid, abbreviation] of Object.entries(config.abbreviations)){
			if((from.chainId==137 && cid==to.chainId) || (to.chainId==137 && cid==from.chainId)){
				chainSelect+='<option selected value="'+cid+'">'+config.chainNames[cid]+'</option>';
			}else{
				chainSelect+='<option value="'+cid+'">'+config.chainNames[cid]+'</option>';
			}

		}
		chainSelect+='</select>';



		$('#from_amount').attr('min', 0);
		$('#from_amount').val('');
		$('#from_amount').attr('max', parseFloat(ethers.formatUnits(from.balance.toString(), from.decimals)));
		$('#from_coin_name').text(from.symbol);
		if(to.chainId==137){
			$('#from_chain_name').html(chainSelect);
		}else{
			$('#from_chain_name').html(from.chainName);
		}

		$('#reverse').attr('src', reverse);
		$('#to_amount').text($('#from_amount').val());
		$('#to_coin_name').text(to.symbol);
		if(from.chainId==137){
			$('#to_chain_name').html(chainSelect);
		}else{
			$('#to_chain_name').html(to.chainName);
		}

	}

	async function getBalances(from, to, address){
		viciCommon.addMessage("Refreshing balances", "message", 30000);
		viciCommon.nextMessage();

		from.balance = await from.coinInstance.balanceOf(address);
		to.balance = await to.coinInstance.balanceOf(address);

		from.lockedBalance = await from.coinInstance.lockedBalanceOf(address);
		from.unlockedBalance = parseFloat(ethers.formatUnits(from.balance.toString(), from.decimals)) - parseFloat(ethers.formatUnits(from.lockedBalance.toString(), from.decimals));
		from.lockReleaseDate = await from.coinInstance.lockReleaseDate(address);
		to.lockedBalance = await to.coinInstance.lockedBalanceOf(address);
		to.unlockedBalance = parseFloat(ethers.formatUnits(to.balance.toString(), to.decimals)) - parseFloat(ethers.formatUnits(to.lockedBalance.toString(), to.decimals));
		to.lockReleaseDate = await to.coinInstance.lockReleaseDate(address);

		from.naitivebalance = await from.provider.getBalance(address);
		to.naitivebalance = await to.provider.getBalance(address);

		viciCommon.nextMessage(true);
	}

	async function setBalances(from, to, address, log){
		await getBalances(from, to, address);
		if(log == true){
			console.debug(from.chainName+' '+from.symbol+' Balance: '+ethers.formatUnits(from.balance.toString(), from.decimals) + ' ('+parseFloat(from.unlockedBalance.toFixed(6))+' unlocked) Unlocks '+timeConverter(parseInt(from.lockReleaseDate)));
			console.debug(to.chainName+' '+to.symbol+' Balance: '+ethers.formatUnits(to.balance.toString(), to.decimals)+ ' ('+parseFloat(to.unlockedBalance.toFixed(6))+' unlocked) Unlocks '+timeConverter(parseInt(to.lockReleaseDate)));
			console.debug(from.chainName+' Balance: '+parseFloat(ethers.formatUnits(from.naitivebalance.toString(), from.decimals)).toFixed(6))
			console.debug(to.chainName+' Balance: '+parseFloat(ethers.formatUnits(to.naitivebalance.toString(), to.decimals)).toFixed(6))
		}

		if(from.unlockedBalance > 0.001){//Fix odd float sci
			$('#from_balance').text(from.chainName+' '+from.symbol+' Balance: '+parseFloat(ethers.formatUnits(from.balance.toString(), from.decimals)).toFixed(3)+ ' ('+from.unlockedBalance.toFixed(3)+' Unlocked)');
		}else{
			$('#from_balance').text(from.chainName+' '+from.symbol+' Balance: '+(ethers.formatUnits(from.balance.toString(), from.decimals)));
		}

		if(to.unlockedBalance > 0.001){
			$('#to_balance').text(to.chainName+' '+to.symbol+' Balance: '+parseFloat(ethers.formatUnits(to.balance.toString(), to.decimals)).toFixed(3)+ ' ('+to.unlockedBalance.toFixed(3)+' Unlocked)');
		}else{
			$('#to_balance').text(to.chainName+' '+to.symbol+' Balance: '+(ethers.formatUnits(to.balance.toString(), to.decimals)));
		}

		if(from.lockedBalance > 0){
			$('#unlock_date').text(from.chainName+ " Coins unlock "+timeConverter(parseInt(from.lockReleaseDate)));
		}
		if(to.lockedBalance > 0){
			$('#unlock_date').text(to.chainName+ " Coins unlock "+timeConverter(parseInt(to.lockReleaseDate)));
		}
	}

	function timeConverter(UNIX_timestamp){
		let a = new Date(UNIX_timestamp * 1000);
		let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
		let year = a.getFullYear();
		let month = months[a.getMonth()];
		let date = a.getDate();
		let hour = "0" + a.getHours();
		let ampm = 'am';
		if(hour >= 12)
			ampm = 'pm';
		if(hour > 12)
			hour = parseInt(hour) - 12;
		if(hour == 0)
			hour = 12;
		let min = "0" + a.getMinutes();
		let time = month + ' ' + date + ' ' + year + ' at ' + String(hour).substr(-2) + ':' + min.substr(-2)+ampm ;
		return time;
	}
});